import {reverse} from "@Common/utils/collections";

export const scales = [
    ...reverse(goUp(1,20, 1/1.1)),
    1,
    ...goUp(1,20, 1.1),
];

function goUp(from, count, ratio) {
    let ret = [];
    let current = from;
    for (let i = 0; i < count; i++) {
        current = current * ratio;
        ret.push(current);
    }
    return ret;
}